// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__1w7_h","icon":"SortAdornment_icon__3lxtw","up":"SortAdornment_up__2vjnE","down":"SortAdornment_down__1fnF3","active":"SortAdornment_active__UVu_c"};